import * as React from 'react';
import { createService } from '../createService';
import { PremiumIcon } from '../icons';

export const PremiumService = createService({
  title: 'Премиум',
  subTitle: 'Заметнее в поиске',
  description: ['Больше просмотров', '1 фото и ваш заголовок'],
  dataName: 'PremiumService',
  bgColor: 'white',
  icon: <PremiumIcon />,
});
